import { Component } from '@verndale/core';
import { element } from 'prop-types';

const hoverCard = ($element) => {
  if ($element.tagName !== 'A' && !$element._$('a')) return;
  $element.classList.add('hover-card');
};

export default hoverCard;
